/* @flow */
import actionTypes from '../actions/types';
import v1ActionTypes from '../actions/actionsFactory/types';

const NATIVE_CURRENCY = 'nativeCurrency';

const KYC_STATUS = {
  unverified: -1,
  pending: 0,
  verified: 1,
  rejected: 2,
};

export type UserInfo = {
  mobileSecurity?: boolean,
  mobileNo?: string,
  email?: string,
  gauth?: boolean,
  isKYCValidated?: number,
  isAddressValidated?: number,
  firstName?: string,
  lastName?: string,
  middleName?: string,
  userId?: string,
  subUser?: false,
  withdrawWhiteStatus?: boolean,
  agentRewardRatio?: number,
};

export type UserConfig = {
  configName: string,
  configType: string,
};

export const INITIAL_STATE = {
  antiCode: undefined,
  isLoggedIn: undefined,
  userInfo: {
    fetched: false,
    commissionStatus: 2,
    isKYCValidated: undefined,
    isAddressValidated: undefined,
    isExistMarginAccount: false,
    subUser: false,
  },
  userTradeFee: {},
  userGasRate: 1,
  userDividends: [],
  userLogs: [],
  userDevicesList: [],
  userConfig: [],
  userAntiPhishingCode: '',
  userPreferredCurrency: undefined,
  deviceHistoryData: {},
  userFaitBalance: 0,
  listenKey: undefined,
  userKYCInfo: {},
};

const handleUpdateDeviceHistoryData = (state, { deviceId, data }) => {
  const deviceHistoryData = { ...state.deviceHistoryData, [deviceId]: data };
  return { ...state, deviceHistoryData, deviceId };
};

const onFetchKYCInfoSuccess = (userInfo, { kycStatus }) => Object.assign({}, userInfo, {
  isKYCValidated: kycStatus === KYC_STATUS.verified,
});

const onFetchUserPreferredCurrencySuccess = data => data.find(config => config.configType === NATIVE_CURRENCY);

export const reducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.USER_STATE_LOGGED_IN:
      return { ...state, isLoggedIn: true };
    case actionTypes.USER_STATE_LOGGED_OUT:
      return { ...state, isLoggedIn: false };
    case actionTypes.SET_USER_INFO:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.data,
          fetched: true,
        },
      };
    case actionTypes.SET_ANTI_CODE:
      return {
        ...state,
        antiCode: action.data,
      };
    case actionTypes.SET_USER_TRADE_FEE:
      return { ...state, userTradeFee: action.data };
    case actionTypes.SET_USER_DIVIDENDS:
      return { ...state, userDividends: action.data.data, userDividendsTotal: action.data.total };
    case actionTypes.SET_USER_LOGS:
      return { ...state, userLogs: action.data.data };
    case actionTypes.SET_USER_DEVICES_LIST:
      return { ...state, userDevicesList: action.data || [] };
    case actionTypes.SET_USER_ANTI_PHISHING_CODE:
      return { ...state, userAntiPhishingCode: action.data };
    case actionTypes.SET_LISTEN_KEY:
      return { ...state, listenKey: action.data };
    case actionTypes.SET_DEVICE_HISTORY_DATA:
      return handleUpdateDeviceHistoryData(state, action);
    case actionTypes.SET_SYMBOL_BY_ASSET:
      return { ...state, tradeSymbols: action.symbols };
    case actionTypes.SET_CHARGE_ADDRESS:
      return { ...state, userChargeAddress: action.data };
    case actionTypes.SET_CUR_USER_ASSETS:
      return { ...state, userCurAsset: action.data };
    case actionTypes.SET_USER_MONEY_LOG:
      return {
        ...state,
        userMoneyLog: action.data,
      };
    case actionTypes.SET_USER_GAS_RATE:
      return { ...state, userGasRate: Number(action.data) };
    case actionTypes.SET_CREATE_ACCOUNT_FOCUS:
      return { ...state, createAccountPageFocus: action.data };
    case actionTypes.FETCH_KTC_INFO_SUCCESS:
      return { ...state, userInfo: onFetchKYCInfoSuccess(state.userInfo, action.data), userKYCInfo: { ...action.data } };
    case actionTypes.FETCH_USER_CONFIG_SUCCESS:
      return Array.isArray(action.data)
        ? {
          ...state,
          userConfig: action.data,
          userPreferredCurrency: onFetchUserPreferredCurrencySuccess(action.data),
        }
        : state;
    case actionTypes.SET_NATIVE_CURRENCY_DATA:
      return { ...state, userPreferredCurrency: action.data };
    case actionTypes.UPDATA_USER_COMMISSION_STATUS_SUCCESS:
      return { ...state, userInfo: { ...state.userInfo, commissionStatus: action.data } };
    case v1ActionTypes.UPDATA_WITHDRAW_WHITE_STATUS_SUCCESS:
      return { ...state, userInfo: { ...state.userInfo, withdrawWhiteStatus: action.data } };
    case actionTypes.SET_BASE_DETAIL:
      return { ...state, userInfo: { ...state.userInfo, agentRewardRatio: action.data.agentRewardRatio } };
    default:
      return state;
  }
};
